import { Store, Module, ActionContext } from "vuex";
import ListModule from "../list-module";
import ListState from "../list-state";
import Ajax from "../../../lib/ajax";
import PageResult from "@/store/entities/page-result";
import ListMutations from "../list-mutations";
import BuyCardRecord from "../../entities/booking/buyCardRecord";

interface CouponState extends ListState<BuyCardRecord> {
  editCoupon: BuyCardRecord;
}
class CouponModule extends ListModule<CouponState, any, BuyCardRecord> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<BuyCardRecord>(),
    loading: false,
    editCoupon: new BuyCardRecord(),
  };
  actions = {
    async getAll(context: ActionContext<CouponState, any>, payload: any) {
      context.state.loading = true;
      let reponse = await Ajax.get("/api/services/app/BuyCardRecord/GetAll", {
        params: payload.data,
      });
      context.state.loading = false;
      let page = reponse.data.result as PageResult<BuyCardRecord>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async createReocrd(context: ActionContext<CouponState, any>, payload: any) {
      await Ajax.post("/api/services/app/BuyCardRecord/CreateReocrd", payload.data);
    },
    async createWithImages(
      context: ActionContext<CouponState, any>,
      payload: any
    ) {
      await Ajax.post(
        "/api/services/app/BuyCardRecord/CreateWithImages",
        payload.data
      );
    },
    async update(context: ActionContext<CouponState, any>, payload: any) {
      await Ajax.put("/api/services/app/BuyCardRecord/Update", payload.data);
    },
    async updateWithImages(
      context: ActionContext<CouponState, any>,
      payload: any
    ) {
      await Ajax.put("/api/services/app/BuyCardRecord/UpdateWithImages", payload.data);
    },
    async delete(context: ActionContext<CouponState, any>, payload: any) {
      context.state.loading = true;
      await Ajax.delete(
        "/api/services/app/BuyCardRecord/Delete?Id=" + payload.data.id
      );
      context.state.loading = false;
    },
    async get(context: ActionContext<CouponState, any>, payload: any) {
      let reponse = await Ajax.get(
        "/api/services/app/BuyCardRecord/Get?Id=" + payload.id
      );
      return reponse.data.result as BuyCardRecord;
    },
    async CreateCourtCouponForAllUsers(
      context: ActionContext<CouponState, any>,
      payload: any
    ) {
      console.log(payload.data, "datadata");
      let reponse = Ajax.post(
        "/api/services/app/BuyCardRecord/CreateCourtCouponForAllUsers",
        payload.data
      );
      return reponse;
    },
  };
  mutations = {
    setCurrentPage(state: CouponState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: CouponState, pagesize: number) {
      state.pageSize = pagesize;
    },
    edit(state: CouponState, buyCardRecord: BuyCardRecord) {
      state.editCoupon = buyCardRecord;
    },
    changeLoading(state: CouponState, pass: boolean) {
      state.loading = pass;
    },
  };
}
const couponModule = new CouponModule();
export default couponModule;
